// A change to the look plays as a wipe from the centre, where the browser can
// do it (the View Transitions API), and simply happens where it cannot.

export function withWipe(change: () => void) {
  const doc = document as Document & { startViewTransition?: (cb: () => Promise<void> | void) => { finished: Promise<void> } };
  const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  if (!doc.startViewTransition || reduce || document.documentElement.classList.contains("is-wiping")) return change();
  document.documentElement.classList.add("is-wiping");
  const t = doc.startViewTransition(async () => {
    change();
    // the scene redraws in an effect, which runs on a task: give it one before the
    // new look is captured. Not animation frames, which do not run while the
    // browser holds rendering for the transition.
    await new Promise<void>((r) => setTimeout(r, 48));
  });
  void t.finished.finally(() => document.documentElement.classList.remove("is-wiping"));
}
